const { useSortable } = require("@dnd-kit/sortable")
const { CSS } = require("@dnd-kit/utilities")
const { flexRender } = require("@tanstack/react-table")

const DraggableRow = ({ row, isCategory, parentId }) => {
  const { transform, transition, setNodeRef, isDragging } = useSortable({
    id: row.original.id,
    data: { parentId: parentId },
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 1 : 0,
    ...(isCategory ? { backgroundColor: "Gainsboro" } : {}),
  }
  return (
    <tr ref={setNodeRef} style={style}>
      {row.getVisibleCells().map(cell => (
        <td key={cell.id} className="px-6 py-2 whitespace-nowrap">
          <div className="flex items-center">
            <div className="text-sm text-gray-900">
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </div>
          </div>
        </td>
      ))}
    </tr>
  )
}

export default DraggableRow
